// Same rule as the server (driverApplicationValidators.typedNameMatches):
// accents, case, spaces and punctuation are ignored, and the typed name must
// contain the first and last name from the application.
const compactName = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/[^a-z]/g, '');

export const typedNameMatches = (typed, firstName, lastName) => {
  const t = compactName(typed);
  const first = compactName(firstName);
  const last = compactName(lastName);
  return Boolean(t && first && last && t.includes(first) && t.includes(last));
};

export default typedNameMatches;
